<template lang="pug">
  .wrapper
    v-layout(row justify-end).pt-4.mb-2
      v-btn(icon, class="mr-3 info-icon", @click="showInfoDialog")
        v-icon(large) help_outline
      div.userInfo
        v-icon.userInfo__icon.mr-3 person
        span.userInfo__title.mr-3 {{ userName }}
      v-btn(large round block @click="logout" color="white").exit-btn.hidden-xs-only Выход
        v-icon(right) exit_to_app
      v-btn(large icon @click="logout" color="white").exit-btn.hidden-sm-and-up
        v-icon exit_to_app
</template>

<script>
export default {
  name: 'UserInfo',
  mounted() {
    this.$store.dispatch('GET_USER_NAME')
  },
  computed: {
    userName() {
      return this.$store.state.userInfo.user.name
    }
  },
  methods: {
    logout() {
      this.$store.dispatch('SET_LOGOUT')
      window.SmartId.closeSession()
    },
    showInfoDialog() {
      this.$emit('show-info-dialog')
    }
  }
}
</script>

<style lang="scss" scoped>
.info-icon {
  transform: translateY(6px);
}
.userInfo {
  border-right: 1px solid #fff;
  margin-right: 16px;
  &__icon {
    width: 44px;
    height: 44px;
    background: #fff;
    border-radius: 25px;
    color: #007bff !important;
    transform: translateY(7px);
  }
  &__title {
    color: #fff;
    font-size: 1.2rem;
    font-weight: 500;
    display: inline-block;
    transform: translateY(-7px);
  }
}
.exit-btn {
  color: #007bff !important;
  border-radius: 25px;
}
@media only screen and (max-width: 600px) {
  .userInfo {
    border-right: transparent;
    margin-right: 0;
    &__icon {
      display: none;
    }
    &__title {
      font-size: 1.1rem;
      transform: translateY(17px);
    }
  }
  .exit-btn {
    height: 40px;
    width: 40px;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/UserInfo/UserInfo.vue